module.exports = __webpack_public_path__ + "static/media/editProfile.9dec32e9.svg";